import React, { useState } from 'react';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from './ui/Button';
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-800" data-id="element-40">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none" data-id="element-41">
        <span className="text-lg font-bold text-white pr-8" data-id="element-42">{question}</span>
        {isOpen ? <ChevronUp className="text-[#FF6B00] shrink-0" data-id="element-43" /> : <ChevronDown className="text-[#22C55E] shrink-0" data-id="element-44" />}
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96 opacity-100 mb-6' : 'max-h-0 opacity-0'}`} data-id="element-45">
        <p className="text-gray-400 leading-relaxed" data-id="element-46">{answer}</p>
      </div>
    </div>;
};
export function FAQSection() {
  const faqs = [{
    question: '¿Cuánto tiempo tarda en hacer efecto?',
    answer: 'La mayoría de nuestros usuarios reportan sentir mayor energía y vitalidad desde la primera semana. Los cambios físicos visibles suelen notarse a partir de la semana 3-4 de implementación.'
  }, {
    question: '¿Es seguro?',
    answer: 'Varamax es un método   100% natural, sin estimulantes ni sustancias prohibidas.'
  }, {
    question: '¿Cómo funciona el envío?',
    answer: 'El envío es al instante. Una vez aprobado el pago se envía al email ingresado.'
  }, {
    question: '¿Qué pasa si no funciona para mí?',
    answer: 'Tienes nuestra garantía de 30 días. Si no estás satisfecho, nos escribes y te devolvemos tu dinero. El riesgo es todo nuestro.'
  }];
  return <Section background="darker" data-id="element-47">
      <div className="text-center mb-12" data-id="element-48">
        <h2 className="text-2xl md:text-3xl font-bold text-white uppercase mb-4" data-id="element-49">
          RESOLVEMOS TUS DUDAS ANTES DE QUE EMPIECES
        </h2>
      </div>

      <div className="max-w-2xl mx-auto mb-12" data-id="element-50">
        {faqs.map((faq, idx) => <FAQItem key={idx} {...faq} data-id="element-51" />)}
      </div>

      <div className="text-center" data-id="element-52">
        <Button size="lg" href="https://tododigitalizado.site/cart/add?id=43131978317958&quantity=1" data-id="element-53">
          QUIERO EMPEZAR HOY MISMO
        </Button>
      </div>
    </Section>;
}